// apps/web/src/lib/format-eur.ts
//
// Compact EUR formatter shared by the dashboard fine surfaces (T4 tile,
// pulse strip, highlights band). Extracted from T4NewFinesTile (KAN-209).

export function formatEur(amount: number): string {
  if (amount >= 1_000_000) return `€${(amount / 1_000_000).toFixed(1)}M`
  if (amount >= 1_000) return `€${(amount / 1_000).toFixed(0)}k`
  return `€${amount.toLocaleString('en-GB')}`
}
